import moment = require('moment');
import {
  ETableActionType,
  ITableKey,
} from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import {
  IAccordionItem,
  IObjectKey,
} from 'src/app/modules/shared/models/objects';

export enum EDetailAccordionTypes {
  POLICY = 'POLICY',
  COUNTERVALUE = 'COUNTERVALUE',
  CUSTOMER = 'CUSTOMER',
  INSURED = 'INSURED',
  BENEFICIARY = 'BENEFICIARY',
  PAYMENT = 'PAYMENT',
  DOCUMENTS = 'DOCUMENTS',
  TUTOR = 'TUTOR',
  MOVEMENTS = 'MOVEMENTS',
  SHARES = 'SHARES',
  FORWARDS = 'FORWARDS',
  SWITCH = 'SWITCH',
  ESTEMPORANEI = 'ESTEMPORANEI',
  TITLES = 'TITLES',
  LETTERS = 'LETTERS',
  TRANSFERS = 'TRANSFERS',
  FISCALCARD = 'FISCALCARD'
}

// LABELS DETTAGLIO
const NUMERO_POLIZZA_BPER_LABEL: string = 'Numero polizza BPER';
const NUMERO_POLIZZA_COMPAGNIA_LABEL: string = 'Numero polizza Compagnia';
const PRODOTTO_LABEL: string = 'Prodotto';
const CODICE_PROD_COMP_LABEL: string = 'Codice prodotto Compagnia';
const PREMIO_LABEL: string = 'Premio';
const DATA_EMISSIONE_LABEL: string = 'Data emissione';
const DATA_DECORRENZA_LABEL: string = 'Data decorrenza';
const DATA_ISCRIZIONE_LABEL: string = 'Data prima iscrizione';
export const ADESION_TYPE_LABEL: string = 'Tipo Adesione';
export const FULL_ADDRESS_UNI30_LABEL: string = 'Indirizzo';
const DATA_PRIMA_ADESIONE_LABEL: string = 'Data adesione';
const DATA_SCADENZA_LABEL: string = 'Data scadenza';
const DATA_FINE_PAG_PREMI_LABEL: string = 'Data fine pagamenti premi';
const CONTROVALORE_LABEL: string = 'Controvalore';
const FONDO_LABEL: string = 'Fondo';
const NUM_FINANZIAMENTO_LABEL: string = 'Numero finanziamento';
const NUM_CONTRATTO_LABEL: string = 'Numero contratto';
const COD_CONVENZIONE_LABEL: string = 'Codice convenzione';
const STATO_PIANO_PAG_LABEL: string = 'Stato piano pagamenti';
const FILIALE_RELAZIONE_LABEL: string = 'Filiale di relazione';
const FILIALE_GESTIONE_LABEL: string = 'Filiale di gestione';
const FILIALE_COMPAGNIA_LABEL: string = 'Filiale di Compagnia';
const SCHEMA_FINANZIARIO_LABEL: string = 'Schema Finanziario';
const POLIZZA_DIFFERITA_LABEL: string = 'Polizza differita';
const TOT_VERSAMENTI_LABEL: string = 'Totale versamenti';
const DATA_ULTIMA_VAL_LABEL: string = 'Data ultima valorizzazione';
const DATA_ULTIMO_VERSAMENTO_LABEL: string = 'Data ultimo versamento';
const DATA_ESTINZIONE_LABEL: string = 'Data estinzione';
const ALLOCAZIONE_RAMI_LABEL: string = 'Allocazione rami';
const VALORE_POLIZZA_LABEL: string = 'Valore polizza';
const NOME_FONDO_LABEL: string = 'Nome Fondo';
const IMPORTO_LABEL: string = 'Importo';
const NAV_LABEL: string = 'Importo quota';
const PERCENTUALE_LABEL: string = 'Percentuale';
const MAX_ASSICURATO_INIZ_LABEL: string = 'Massimale Assicurato iniziale';
const IMPORTO_PREMI_SUCCESSIVI_LABEL: string = 'Importo premi successivi';
const IMPORTO_RATA_PERIODICA_LABEL: string = 'Importo rata periodica';
const PERIODICITA_LABEL: string = 'Periodicità';
const POLICY_HOLDER_DATA_NASCITA_LABEL: string = 'Data di nascita';
const CODICE_FISCALE_LABEL: string = 'Codice fiscale';
const MODALITA_PAGAMENTO_LABEL: string = 'Modalità di pagamento';
const DATI_VERSAMRNTO_PREMIO_LABEL: string = 'Dati versamento premio';
const ADDEBITO_CONTO_LABEL: string = 'Addebito in conto';
const CONTO_CORRENTE_LABEL: string = 'Conto Corrente';
const IBAN_LABEL: string = 'Iban';
const INTESTATARIO_CC_LABEL: string = 'Intestatario C/C';
const TUTORE_LABEL: string = 'Tutore / Legale Rappresentante';
const COMPARTO_TABLE_COMPARTO_LABEL: string = 'Comparto';
const COMPARTO_TABLE_PERCENTUALE_LABEL: string = '% Allocazione iscritto';
const COMPARTO_EMPLOYER_TABLE_PERCENTUALE_LABEL: string = '% Allocazione Datore di lavoro';
const COMPARTO_TFR_TABLE_PERCENTUALE_LABEL: string = '% Allocazione Tfr';
export const SHARES_COUNTERVALUE_LABEL: string = 'Totale Controvalore';
const IPO_VAL_RISCATTO_PREMI_LABEL: string = 'Cumulo Premi';
const IPO_VAL_RISCATTO_LORDO_LABEL: string = 'Ipotesi Valore Riscatto Lordo';
const IPO_VAL_RISCATTO_NETTO_LABEL: string = 'Ipotesi Valore Riscatto Netto';
const IPO_VAL_RISCATTO_IMPOSTA_LABEL: string = 'Imposta';
const IPO_VAL_RISCATTO_BOLLO_LABEL: string = 'Bollo';
export const DATA_LABEL: string = 'Data';
export const PEGNO_VINCOLO_LABEL: string = 'Pegno Vincolo';

// KEYS DETTAGLIO
const NUMERO_POLIZZA_BPER_KEY: string = 'summary.bperPolicyNumber';
const NUMERO_POLIZZA_COMPAGNIA_KEY: string = 'summary.companyPolicyNumber';
const PRODOTTO_KEY: string = 'summary.productDescription';
const CODICE_PROD_COMP_KEY: string = 'summary.productCode';
const PREMIO_KEY: string = 'summary.prizeType';
const DATA_EMISSIONE_KEY: string = 'summary.emissionDate';
const DATA_DECORRENZA_KEY: string = 'summary.effectDate';
const DATA_ISCRIZIONE_KEY: string =
  'intesaFurtherDetails.uni30.summary.subscriptionDate';
const ADESION_TYPE_KEY: string = 'intesaFurtherDetails.uni30.summary.adesionType';
export const FULL_ADDRESS_UNI30_KEY = 'fullAddress';
const DATA_PRIMA_ADESIONE_KEY: string =
  'intesaFurtherDetails.uni30.summary.adesionDate';
const DATA_SCADENZA_KEY: string = 'summary.expiryDate';
const DATA_FINE_PAG_PREMI_KEY: string = 'summary.lastPremiumPaymentDate';
const CONTROVALORE_KEY: string = 'policyValue.insuredAmount';
const NUM_FINANZIAMENTO_KEY: string = 'summary.financingNumber';
const NUM_CONTRATTO_KEY: string = 'policyExtraInfo.contractNumber';
const COD_CONVENZIONE_KEY: string = 'policyExtraInfo.conventionCode';
const STATO_PIANO_PAG_KEY: string = 'policyExtraInfo.paymentsState';
const FILIALE_RELAZIONE_KEY: string = 'policyExtraInfo.agencyCode';
const FILIALE_GESTIONE_KEY: string = 'policyExtraInfo.branchOffice';
const SCHEMA_FINANZIARIO_KEY: string =
  'intesaFurtherDetails.uni30.policyValue.financingScheme';
const POLIZZA_DIFFERITA_KEY: string = 'summary.isPolicyDeferred';
const TOT_VERSAMENTI_KEY: string = 'policyValue.totalPayments';
const DATA_ULTIMA_VAL_KEY: string = 'policyValue.lastValorizationDate';
const DATA_ULTIMA_ELAB_KEY: string = 'intesaFurtherDetails.uni20.ipotesiValoreRiscatto.elaborationDate';
const DATA_UTLIMO_VERSAMENTO_KEY: string = 'policyValue.lastPaymentDate';
const DATA_ESTINZIONE_KEY: string = 'policyValue.expiryDate';
const ALLOCAZIONE_RAMI_KEY: string = 'summary.currentRiskDescription';
const NOME_FONDO_KEY: string = 'description';
const IMPORTO_KEY: string = 'fundAmount';
const NAV_KEY: string = 'quoteValue';
const PERCENTUALE_KEY: string = 'percentage';
const MAX_ASSICURATO_INIZ_KEY: string = 'policyValue.insuredMaximum';
const CONTO_CORRENTE_KEY: string = 'policyValue.codeRapporto';
const IBAN_KEY: string = 'intesaFurtherDetails.uni30.premiumPayment.iban';
const INTESTATARIO_CC_KEY: string = 'policyValue.intestazioneRapporto';
const IMPORTO_PREMI_SUCCESSIVI_KEY: string = 'policyValue.nextPremiumsAmount';
const IMPORTO_PREMI_ANNUALE_KEY: string = 'intesaFurtherDetails.uni30.premiumPayment.annualInstalment';
const NDG_CLIENTE_KEY: string = 'policyExtraInfo.ndg';
const POLICY_HOLDER_TAX_VAT_CODE_KEY: string = 'policyHolder.taxOrVatCode';
const POLICY_HOLDER_NATURA_GIURIDICA: string = 'policyHolder.type';
const COMPARTO_TABLE_COMPARTO_KEY: string = 'description';
const COMPARTO_TABLE_PERCENTUALE_KEY: string = 'percentage';
const COMPARTO_TFR_TABLE_COMPARTO_KEY: string = 'tfrPercentage';
const COMPARTO_EMPLOYER_TABLE_PERCENTUALE_KEY: string = 'employerPercentage';
const IPO_VAL_RISCATTO_PREMI_KEY: string = 'intesaFurtherDetails.uni20.ipotesiValoreRiscatto.totalPremium';
const IPO_VAL_RISCATTO_LORDO_KEY: string = 'intesaFurtherDetails.uni20.ipotesiValoreRiscatto.grossAmount';
const IPO_VAL_RISCATTO_NETTO_KEY: string = 'intesaFurtherDetails.uni20.ipotesiValoreRiscatto.netAmount';
const IPO_VAL_RISCATTO_IMPOSTA_KEY: string = 'intesaFurtherDetails.uni20.ipotesiValoreRiscatto.tax';
const IPO_VAL_RISCATTO_BOLLO_KEY: string = 'intesaFurtherDetails.uni20.ipotesiValoreRiscatto.stampDuty';
const DATA_KEY: string = 'investmentDate'
export const PEGNO_VINCOLO_KEY: string = 'intesaFurtherDetails.uni20.pegnoVincolo';

export type TDetailAccordionTypes = keyof typeof EDetailAccordionTypes;

export interface IPolicyKeys {
  header: IObjectKey[];
  accordions: IAccordionItem<TDetailAccordionTypes>[];
}

export const TRAD_policy_header_keys: IObjectKey[] = [
  {
    label: NUMERO_POLIZZA_BPER_LABEL,
    key: NUMERO_POLIZZA_BPER_KEY,
  },
  {
    label: NUMERO_POLIZZA_COMPAGNIA_LABEL,
    key: NUMERO_POLIZZA_COMPAGNIA_KEY,
  },
  {
    label: PRODOTTO_LABEL,
    key: PRODOTTO_KEY,
  },
  {
    label: CODICE_PROD_COMP_LABEL,
    key: CODICE_PROD_COMP_KEY,
  },
  {
    label: PREMIO_LABEL,
    key: PREMIO_KEY,
  },
  {
    label: DATA_EMISSIONE_LABEL,
    key: DATA_EMISSIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_DECORRENZA_LABEL,
    key: DATA_DECORRENZA_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_SCADENZA_LABEL,
    key: DATA_SCADENZA_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_FINE_PAG_PREMI_LABEL,
    key: DATA_FINE_PAG_PREMI_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: CONTROVALORE_LABEL,
    key: CONTROVALORE_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
];

export const MULTIRAMO_policy_header_keys: IObjectKey[] = [
  {
    label: NUMERO_POLIZZA_BPER_LABEL,
    key: NUMERO_POLIZZA_BPER_KEY,
  },
  {
    label: NUMERO_POLIZZA_COMPAGNIA_LABEL,
    key: NUMERO_POLIZZA_COMPAGNIA_KEY,
  },
  {
    label: PRODOTTO_LABEL,
    key: PRODOTTO_KEY,
  },
  {
    label: CODICE_PROD_COMP_LABEL,
    key: CODICE_PROD_COMP_KEY,
  },
  {
    label: PREMIO_LABEL,
    key: PREMIO_KEY,
  },
  {
    label: DATA_EMISSIONE_LABEL,
    key: DATA_EMISSIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_DECORRENZA_LABEL,
    key: DATA_DECORRENZA_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_SCADENZA_LABEL,
    key: DATA_SCADENZA_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_FINE_PAG_PREMI_LABEL,
    key: DATA_FINE_PAG_PREMI_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: CONTROVALORE_LABEL,
    key: CONTROVALORE_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
];

export const UNIT_policy_header_keys: IObjectKey[] = [
  {
    label: NUMERO_POLIZZA_BPER_LABEL,
    key: NUMERO_POLIZZA_BPER_KEY,
  },
  {
    label: NUMERO_POLIZZA_COMPAGNIA_LABEL,
    key: NUMERO_POLIZZA_COMPAGNIA_KEY,
  },
  {
    label: PRODOTTO_LABEL,
    key: PRODOTTO_KEY,
  },
  {
    label: CODICE_PROD_COMP_LABEL,
    key: CODICE_PROD_COMP_KEY,
  },
  {
    label: PREMIO_LABEL,
    key: PREMIO_KEY,
  },
  {
    label: DATA_EMISSIONE_LABEL,
    key: DATA_EMISSIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_DECORRENZA_LABEL,
    key: DATA_DECORRENZA_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_SCADENZA_LABEL,
    key: DATA_SCADENZA_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_FINE_PAG_PREMI_LABEL,
    key: DATA_FINE_PAG_PREMI_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: CONTROVALORE_LABEL,
    key: CONTROVALORE_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
];

export const PREV_QUOTE_FILTER_KEY: IFormKey[] = [
  {
    id: 'dateFilter-field',
    controlName: 'dateFilter',
    label: 'Inserisci Data',
    css: 'col-3',
    type: 'DATEPICKER',
    maxDate: moment(),
  },
  {
    id: 'filterButton',
    controlName: 'filterButton',
    label: 'FILTRA',
    css: 'col-3',
    type: 'BUTTON',
    action: null,
  },
];

export const PREV_policy_header_keys: IObjectKey[] = [
  {
    label: NUMERO_POLIZZA_BPER_LABEL,
    key: NUMERO_POLIZZA_BPER_KEY,
  },
  {
    label: NUMERO_POLIZZA_COMPAGNIA_LABEL,
    key: NUMERO_POLIZZA_COMPAGNIA_KEY,
  },
  {
    label: FONDO_LABEL,
    key: PRODOTTO_KEY,
  },
  {
    label: CONTROVALORE_LABEL,
    key: CONTROVALORE_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: PREMIO_LABEL,
    key: PREMIO_KEY,
  },
  {
    label: DATA_DECORRENZA_LABEL,
    key: DATA_DECORRENZA_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_ISCRIZIONE_LABEL,
    key: DATA_ISCRIZIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: ADESION_TYPE_LABEL,
    key: ADESION_TYPE_KEY,
  },
  {
    label: DATA_PRIMA_ADESIONE_LABEL,
    key: DATA_PRIMA_ADESIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_SCADENZA_LABEL,
    key: DATA_SCADENZA_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: SCHEMA_FINANZIARIO_LABEL,
    key: SCHEMA_FINANZIARIO_KEY
  }
];

export const TCM_policy_header_keys: IObjectKey[] = [
  {
    label: NUMERO_POLIZZA_BPER_LABEL,
    key: NUMERO_POLIZZA_BPER_KEY,
  },
  {
    label: NUMERO_POLIZZA_COMPAGNIA_LABEL,
    key: NUMERO_POLIZZA_COMPAGNIA_KEY,
  },
  {
    label: PRODOTTO_LABEL,
    key: PRODOTTO_KEY,
  },
  {
    label: CODICE_PROD_COMP_LABEL,
    key: CODICE_PROD_COMP_KEY,
  },
  {
    label: PREMIO_LABEL,
    key: PREMIO_KEY,
  },
  {
    label: DATA_EMISSIONE_LABEL,
    key: DATA_EMISSIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_DECORRENZA_LABEL,
    key: DATA_DECORRENZA_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_SCADENZA_LABEL,
    key: DATA_SCADENZA_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_FINE_PAG_PREMI_LABEL,
    key: DATA_FINE_PAG_PREMI_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: NUM_FINANZIAMENTO_LABEL,
    key: NUM_FINANZIAMENTO_KEY,
  },
];

export const TRAD_policy_form_keys: IObjectKey[] = [
  {
    label: NUMERO_POLIZZA_BPER_LABEL,
    key: NUMERO_POLIZZA_BPER_KEY,
  },
  {
    label: NUMERO_POLIZZA_COMPAGNIA_LABEL,
    key: NUMERO_POLIZZA_COMPAGNIA_KEY,
  },
  {
    label: NUM_CONTRATTO_LABEL,
    key: NUM_CONTRATTO_KEY,
  },
  {
    label: COD_CONVENZIONE_LABEL,
    key: COD_CONVENZIONE_KEY,
  },
  {
    label: STATO_PIANO_PAG_LABEL,
    key: STATO_PIANO_PAG_KEY,
  },
  {
    label: FILIALE_RELAZIONE_LABEL,
    key: FILIALE_RELAZIONE_KEY,
  },
  {
    label: FILIALE_GESTIONE_LABEL,
    key: FILIALE_GESTIONE_KEY,
  },
  {
    label: POLIZZA_DIFFERITA_LABEL,
    key: POLIZZA_DIFFERITA_KEY,
  },
];

export const PREV_uni20_compartment_data_keys: IObjectKey[] = [
  {
    label: FILIALE_GESTIONE_LABEL,
    key: FILIALE_GESTIONE_KEY,
  },
  {
    label: FILIALE_COMPAGNIA_LABEL,
    key: 'policyExtraInfo.companyCab',
  },
  {
    label: SCHEMA_FINANZIARIO_LABEL,
    key: 'intesaFurtherDetails.uni20.financingScheme',
    defaultValue: 'N/A'
  },
{
    label: '',
    key: 'intesaFurtherDetails.uni20.compartmentData',
    type: 'TABLE',
    tableKeys: [
      {
        label: COMPARTO_TABLE_COMPARTO_LABEL,
        key: COMPARTO_TABLE_COMPARTO_KEY,
        defaultValue: 'N/A',
      },
      {
        label: COMPARTO_TABLE_PERCENTUALE_LABEL,
        key: COMPARTO_TABLE_PERCENTUALE_KEY,
        defaultValue: 'N/A'
      },
    ]
  }
];

export const PREV_policy_form_keys: IObjectKey[] = [
  {
    label: FILIALE_GESTIONE_LABEL,
    key: 'intesaFurtherDetails.uni30.policyValue.handleAgency',
  },
  {
    label: FILIALE_COMPAGNIA_LABEL,
    key: 'policyExtraInfo.companyCab',
  },
  {
    label: SCHEMA_FINANZIARIO_LABEL,
    key: SCHEMA_FINANZIARIO_KEY,
  },
  {
    label: POLIZZA_DIFFERITA_LABEL,
    key: POLIZZA_DIFFERITA_KEY,
  },
  {
    label: '',
    key: 'policyValue.funds',
    type: 'TABLE',
    tableKeys: [
      {
        label: COMPARTO_TABLE_COMPARTO_LABEL,
        key: COMPARTO_TABLE_COMPARTO_KEY,
      },
      {
        label: COMPARTO_TABLE_PERCENTUALE_LABEL,
        key: COMPARTO_TABLE_PERCENTUALE_KEY,
      },
      {
        label: COMPARTO_EMPLOYER_TABLE_PERCENTUALE_LABEL,
        key: COMPARTO_EMPLOYER_TABLE_PERCENTUALE_KEY,
      },
      {
        label: COMPARTO_TFR_TABLE_PERCENTUALE_LABEL,
        key: COMPARTO_TFR_TABLE_COMPARTO_KEY,
      },
    ],
    emptyStateMessage: 'Nessun Dato Trovato.'
  },
];

export const PREV_forwards_form_keys: IObjectKey[] = [
  {
    label: '',
    key: 'intesaFurtherDetails.uni30.indirizzamenti',
    type: 'TABLE',
    tableKeys: [
      {
        label: 'Fondo',
        key: 'fundDescription'
      },
      {
        label: 'Data inizio',
        key: 'startDate',
        pipe: {
          key: 'date',
          value: null
        }
      },
      {
        label: 'Data fine',
        key: 'endDate',
        pipe: {
          key: 'date',
          value: null
        }
      },
      {
        label: 'Fonte iscritto',
        key: 'subscriberAmount'
      },
      {
        label: 'Fonte datore',
        key: 'employerAmount'
      },
      {
        label: 'Fonte TFR',
        key: 'TFRamount'
      },
    ],
    emptyStateMessage: 'Nessun Indirizzamento Trovato.'
  }
]

export const PREV_switch_form_keys: IObjectKey[] = [
  {
    key: 'intesaFurtherDetails.uni30.switchHistory',
    type: 'TABLE',
    tableKeys: [
      {
        label: 'Data effetto',
        key: 'effectDate',
        pipe: {
          key: 'date',
        }
      },
      {
        label: 'Fondo provenienza',
        key: 'originFund'
      },
      {
        label: 'Fondo destinazione',
        key: 'destinationFund'
      },
      {
        label: 'Percentuale',
        key: 'percentage'
      }
    ],
    emptyStateMessage: 'Nessuno Switch Trovato.'
  }
];

export const PREV_estemporanei_form_keys: IObjectKey[] = [
  {
    key: 'intesaFurtherDetails.uni30.estemporanei',
    type: 'TABLE',
    tableKeys: [],
    emptyStateMessage: 'Nessun "Estemporaneo" Trovato.'
  }
];

export const PREV_titles_form_keys: IObjectKey[] = [
  {
    label: 'Totale',
    key: 'intesaFurtherDetails.uni30.titoli.total',
    defaultValue: 'N/A',
    pipe: {
      key: 'currency',
      value: 'EUR'
    }
  },
  {
    label: 'Totale Anno Precedente',
    key: 'intesaFurtherDetails.uni30.titoli.lastYearTotal',
    defaultValue: 'N/A',
    pipe: {
      key: 'currency',
      value: 'EUR'
    }
  },
  {
    label: 'Totale Anno in corso',
    key: 'intesaFurtherDetails.uni30.titoli.currentYearTotal',
    defaultValue: 'N/A',
    pipe: {
      key: 'currency',
      value: 'EUR'
    }
  },
  {
    label: null,
    key: null,
    defaultValue: 'Per il dettaglio dei pagamenti consultare la sezione "Quietanze e Pagamenti soprastante.'
  }
];

export const PREV_sent_docs_form_keys: IObjectKey[] = [
  {
    key: 'intesaFurtherDetails.uni30.letters',
    type: 'TABLE',
    tableKeys: [
      {
        label: 'Tipo Lettera',
        key: 'description',
      },
      {
        label: 'Data richiesta',
        key: 'requestDate',
        pipe: {
          key: 'date',
        },
      },
      {
        label: 'Data Consegna',
        key: 'deliveryDate',
        pipe: {
          key: 'date',
        },
      },
      {
        label: 'Anno',
        key: 'year',
      },
      {
        label: 'Beneficiato',
        key: 'beneficiary',
      },
    ],
    emptyStateMessage: 'Nessun Documento Trovato.'
  },
];

export const PREV_liquidation_form_keys: IObjectKey[] = [
  {
    label: 'Totale Liquidato',
    key: 'intesaFurtherDetails.uni30.liquidazioni.total'
  },
  {
    key: 'intesaFurtherDetails.uni30.liquidazioni.liquidationList',
    type: 'TABLE',
    tableKeys: [
      {
        label: 'Compagnia',
        key: 'company'
      },
      {
        label: 'Pratica',
        key: 'practiceNumber'
      },
      {
        label: 'Standard',
        key: 'standard'
      },
      {
        label: 'Data richiesta',
        key: 'requestDate',
        pipe: {
          key: 'date'
        }
      },
      {
        label: 'Liquidazione',
        key: 'liquidationDescription',
        pipe: {
          key: 'currency',
          value: 'EUR'
        }
      },
      {
        label: 'Stato',
        key: 'state'
      },
      {
        label: 'Dematerializzata',
        key: 'dematerialized'
      },
      {
        label: 'Pervenuto',
        key: 'receivedDate',
        pipe: {
          key: 'date',
        }
      },
      {
        label: 'Data chiusura',
        key: 'closureDate',
        pipe: {
          key: 'date',
        }
      },
      {
        label: 'Liquidato',
        key: ''
      },
    ],
    emptyStateMessage: 'Nessuna Liquidazione o Anticipazione presenti.'
  },
]

export const PREV_transfers_form_keys: IObjectKey[] = [
  {
    key: 'intesaFurtherDetails.uni30.trasferimenti',
    type: 'TABLE',
    tableKeys: [
      {
        label: 'Data effetto',
        key: 'effectDate',
        pipe: {
          key: 'date'
        }
      },
      {
        label: 'Stato',
        key: 'state'
      },
      {
        label: 'Data prima iscrizione',
        key: 'firstSubscriptionDate',
        pipe: {
          key: 'date'
        }
      },
      {
        label: 'Data iscrizione provenienza',
        key: 'originRegistrationDate',
        pipe: {
          key: 'date'
        }
      },
      {
        label: 'Data uscita fondo cedente',
        key: 'cedantFundExitDate',
        pipe: {
          key: 'date'
        }
      },
      {
        label: 'Numero iscrizione covip',
        key: 'covipSubscriptionNumber'
      },
      {
        label: 'Denominazione Fondo',
        key: 'fundName'
      },
      {
        label: 'Importo Totale',
        key: 'totalAmount'
      },
    ],
    emptyStateMessage: 'Nessun Trasferimento presente.'
  },
]

export const PREV_fiscal_data_form_keys: IObjectKey[] = [
  {
    label: 'Dati Fiscali',
    key: 'intesaFurtherDetails.uni30.fiscalData.fiscalDataTable',
    type: 'TABLE',
    tableKeys: [
      {
        label: 'Periodo',
        key: 'periodo',
      },
      {
        label: 'Tipo Dati Fiscali',
        key: 'tipoDatiFiscali',
      },
      {
        label: 'Importo Lordo',
        key: 'importoLordo',
      },
      {
        label: 'Tasse versate',
        key: 'tasseVersate',
      },
    ],
    emptyStateMessage: 'Nessun Dato Trovato.'
  }
];


export const PREV_datiContributi_form_keys: IObjectKey[] = [
  {
    label: 'Dati Contributi',
    key: 'intesaFurtherDetails.uni30.fiscalData.productivityPrize',
    type: 'TABLE',
    tableKeys: [
      {
        label: 'Periodo',
        key: 'periodo',
      },
      {
        label: 'Tipo Contributo',
        key: 'tipoContributo',
      },
      {
        label: 'Fonte Iscritto',
        key: 'fonteIscritto',
        pipe: {
          key: 'currency',
          value: 'EUR',
        }
      },
      {
        label: 'Fonte Datore',
        key: 'fonteDatore',
        pipe: {
          key: 'currency',
          value: 'EUR',
        }
      },
      {
        label: 'Fonte TFR',
        key: 'fonteTFR',
        pipe: {
          key: 'currency',
          value: 'EUR',
        }
      },
      {
        label: 'Fonte Totale',
        key: 'fonteTotale',
        pipe: {
          key: 'currency',
          value: 'EUR',
        }
      },
    ],
    emptyStateMessage: 'Nessun Contributo disponibile.'
  },
];

export const PREV_sintesiDatiContributiNonDedotti_form_keys: IObjectKey[] = [
  {
    label: 'Montante Potenziale Totale',
    key: 'intesaFurtherDetails.uni30.fiscalData.montantePotenzialeTotale',
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: 'Montante Effettivo Totale',
    key: 'intesaFurtherDetails.uni30.fiscalData.montanteDisponibileTotale',
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  }]

export const PREV_datiContributiNonDedotti_form_keys: IObjectKey[] = [
  {
    label: 'Contributi non dedotti totale',
    key: 'intesaFurtherDetails.uni30.fiscalData.datiContributiComunicazione.datiContributiNonDedottiTotale',
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: 'Contributi non dedotti da Trasf-IN',
    key: 'intesaFurtherDetails.uni30.fiscalData.datiContributiComunicazione.datiContributiNonDedottiTotaleDaTrasf',
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: 'Dati Contributi Non dedotti',
    key: 'intesaFurtherDetails.uni30.fiscalData.datiContributiComunicazione.datiContributiNonDedotti',
    type: 'TABLE',
    tableKeys: [
      {
        label: 'Periodo',
        key: 'periodo',
      },
      {
        label: 'Tipo Contributo',
        key: 'tipoContributo',
      },
      {
        label: 'Fonte Iscritto',
        key: 'fonteIscritto',
      },
      {
        label: 'Fonte Datore',
        key: 'fonteDatore',
      },
      {
        label: 'Fonte TFR',
        key: 'fonteTFR',
      },
      {
        label: 'Fonte Totale',
        key: 'fonteTotale',
      }
    ],
    emptyStateMessage: 'Nessun Contributo disponibile.'
  }
];

export const PREV_datiContributiPremio_form_keys: IObjectKey[] = [
  {
    label: 'Premio produttività totale',
    key: 'intesaFurtherDetails.uni30.fiscalData.datiContributiComunicazione.datiContributiPremioTotale',
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: 'Premio produttività da Trasf-IN',
    key: 'intesaFurtherDetails.uni30.fiscalData.datiContributiComunicazione.datiContributiPremioTotaleDaTrasf',
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: 'Dati Contributi Premio',
    key: 'intesaFurtherDetails.uni30.fiscalData.datiContributiComunicazione.datiContributiPremio',
    type: 'TABLE',
    tableKeys: [
      {
        label: 'Periodo',
        key: 'periodo',
      },
      {
        label: 'Tipo Contributo',
        key: 'tipoContributo',
      },
      {
        label: 'Fonte Iscritto',
        key: 'fonteIscritto',
      },
      {
        label: 'Fonte Datore',
        key: 'fonteDatore',
      },
      {
        label: 'Fonte TFR',
        key: 'fonteTFR',
      },
      {
        label: 'Fonte Totale',
        key: 'fonteTotale',
      }
    ],
    emptyStateMessage: 'Nessun Contributo premio disponibile.'
  }
];


export const PREV_anticipazioni_form_keys: IObjectKey[] = [
  {
    label: '',
    key: '',
  },
  {
    label: 'ALTRI FONDI - Anticipazioni',
    key: 'intesaFurtherDetails.uni30.fiscalData.anticipazioni.anticipazioni.anticipazioniAltriFondi',
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: 'ALTRI FONDI - Anticipazioni al 30%',
    key: 'intesaFurtherDetails.uni30.fiscalData.anticipazioni.anticipazioni.anticipazioniAltriFondiAl30',
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: 'ALTRI FONDI - Riscatti Parziali',
    key: 'intesaFurtherDetails.uni30.fiscalData.anticipazioni.anticipazioni.riscattiParzialiAltriFondi',
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: '',
    key: '',
  },
  {
    label: 'Max Anticipabile al 30%',
    key: 'intesaFurtherDetails.uni30.fiscalData.anticipazioni.maxAnticipabileAl30',
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: 'Max Anticipabile al 75%',
    key: 'intesaFurtherDetails.uni30.fiscalData.anticipazioni.maxAnticipabileAl75',
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
]


export const TCM_policy_form_keys: IObjectKey[] = [
  {
    label: NUMERO_POLIZZA_BPER_LABEL,
    key: NUMERO_POLIZZA_BPER_KEY,
  },
  {
    label: NUMERO_POLIZZA_COMPAGNIA_LABEL,
    key: NUMERO_POLIZZA_COMPAGNIA_KEY,
  },
  {
    label: NUM_CONTRATTO_LABEL,
    key: NUM_CONTRATTO_KEY,
  },
  {
    label: STATO_PIANO_PAG_LABEL,
    key: STATO_PIANO_PAG_KEY,
  },
  {
    label: FILIALE_RELAZIONE_LABEL,
    key: FILIALE_RELAZIONE_KEY,
  },
  {
    label: FILIALE_GESTIONE_LABEL,
    key: FILIALE_GESTIONE_KEY,
  },
  {
    label: POLIZZA_DIFFERITA_LABEL,
    key: POLIZZA_DIFFERITA_KEY,
  },
];

export const TRAD_countervalue_form_keys: IObjectKey[] = [
  {
    label: CONTROVALORE_LABEL,
    key: CONTROVALORE_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: TOT_VERSAMENTI_LABEL,
    key: TOT_VERSAMENTI_KEY,
  },
  {
    label: DATA_ULTIMA_VAL_LABEL,
    key: DATA_ULTIMA_VAL_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_ULTIMO_VERSAMENTO_LABEL,
    key: DATA_UTLIMO_VERSAMENTO_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_ESTINZIONE_LABEL,
    key: DATA_ESTINZIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
];

export const TRAD_uni20_countervalue_form_keys: IObjectKey[] = [
  {
    label: CONTROVALORE_LABEL,
    key: CONTROVALORE_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: TOT_VERSAMENTI_LABEL,
    key: TOT_VERSAMENTI_KEY,
  },
  {
    label: DATA_ULTIMA_VAL_LABEL,
    key: DATA_ULTIMA_VAL_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_ULTIMO_VERSAMENTO_LABEL,
    key: DATA_UTLIMO_VERSAMENTO_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_ESTINZIONE_LABEL,
    key: DATA_ESTINZIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: IPO_VAL_RISCATTO_PREMI_LABEL,
    key: IPO_VAL_RISCATTO_PREMI_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: IPO_VAL_RISCATTO_LORDO_LABEL,
    key: IPO_VAL_RISCATTO_LORDO_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: IPO_VAL_RISCATTO_NETTO_LABEL,
    key: IPO_VAL_RISCATTO_NETTO_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: IPO_VAL_RISCATTO_IMPOSTA_LABEL,
    key: IPO_VAL_RISCATTO_IMPOSTA_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: IPO_VAL_RISCATTO_BOLLO_LABEL,
    key: IPO_VAL_RISCATTO_BOLLO_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
];

export const MULTIRAMO_countervalue_form_keys: IObjectKey[] = [
  {
    label: CONTROVALORE_LABEL,
    key: CONTROVALORE_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: DATA_ULTIMA_VAL_LABEL,
    key: DATA_ULTIMA_VAL_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: TOT_VERSAMENTI_LABEL,
    key: TOT_VERSAMENTI_KEY,
  },
  {
    label: DATA_ULTIMO_VERSAMENTO_LABEL,
    key: DATA_UTLIMO_VERSAMENTO_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_ESTINZIONE_LABEL,
    key: DATA_ESTINZIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: ALLOCAZIONE_RAMI_LABEL,
    key: ALLOCAZIONE_RAMI_KEY,
  },
  {
    label: VALORE_POLIZZA_LABEL,
    key: 'policyValue.funds',
    type: 'TABLE',
    tableKeys: [
      {
        label: NOME_FONDO_LABEL,
        key: NOME_FONDO_KEY,
      },
      {
        label: IMPORTO_LABEL,
        key: IMPORTO_KEY,
        pipe: {
          key: 'currency',
          value: 'EUR',
        },
      },
      {
        label: PERCENTUALE_LABEL,
        key: PERCENTUALE_KEY,
        pipe: {
          key: 'percentage',
          value: '%',
        },
      },
    ],
  },
];

export const MULTIRAMO_uni20_countervalue_form_keys: IObjectKey[] = [
  {
    label: CONTROVALORE_LABEL,
    key: CONTROVALORE_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: DATA_ULTIMA_VAL_LABEL,
    key: DATA_ULTIMA_ELAB_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: TOT_VERSAMENTI_LABEL,
    key: TOT_VERSAMENTI_KEY,
  },
  {
    label: DATA_ULTIMO_VERSAMENTO_LABEL,
    key: DATA_UTLIMO_VERSAMENTO_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_ESTINZIONE_LABEL,
    key: DATA_ESTINZIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: ALLOCAZIONE_RAMI_LABEL,
    key: ALLOCAZIONE_RAMI_KEY,
  },
  {
    label: IPO_VAL_RISCATTO_PREMI_LABEL,
    key: IPO_VAL_RISCATTO_PREMI_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: IPO_VAL_RISCATTO_LORDO_LABEL,
    key: IPO_VAL_RISCATTO_LORDO_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: IPO_VAL_RISCATTO_NETTO_LABEL,
    key: IPO_VAL_RISCATTO_NETTO_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: IPO_VAL_RISCATTO_IMPOSTA_LABEL,
    key: IPO_VAL_RISCATTO_IMPOSTA_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: IPO_VAL_RISCATTO_BOLLO_LABEL,
    key: IPO_VAL_RISCATTO_BOLLO_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: VALORE_POLIZZA_LABEL,
    key: 'policyValue.funds',
    type: 'TABLE',
    tableKeys: [
      {
        label: NOME_FONDO_LABEL,
        key: NOME_FONDO_KEY,
      },
      {
        label: IMPORTO_LABEL,
        key: IMPORTO_KEY,
        pipe: {
          key: 'currency',
          value: 'EUR',
        },
      },
      {
        label: NAV_LABEL,
        key: NAV_KEY,
        pipe: {
          key: 'currency',
          value: 'EUR',
        },
      },
      {
        label: PERCENTUALE_LABEL,
        key: PERCENTUALE_KEY,
        pipe: {
          key: 'percentage',
          value: '%',
        },
      },
      {
        label: DATA_LABEL,
        key: DATA_KEY,
        pipe: {
          key: 'date',
          value: null,
        }
      }
    ],
  },
];

export const TCM_countervalue_form_keys: IObjectKey[] = [
  {
    label: MAX_ASSICURATO_INIZ_LABEL,
    key: MAX_ASSICURATO_INIZ_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: DATA_ESTINZIONE_LABEL,
    key: DATA_ESTINZIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
];

export const UNIT_countervalue_form_keys: IObjectKey[] = [
  {
    label: CONTROVALORE_LABEL,
    key: CONTROVALORE_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: DATA_ULTIMA_VAL_LABEL,
    key: DATA_ULTIMA_VAL_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: TOT_VERSAMENTI_LABEL,
    key: TOT_VERSAMENTI_KEY,
  },
  {
    label: DATA_ULTIMO_VERSAMENTO_LABEL,
    key: DATA_UTLIMO_VERSAMENTO_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_ESTINZIONE_LABEL,
    key: DATA_ESTINZIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: VALORE_POLIZZA_LABEL,
    key: 'policyValue.funds',
    type: 'TABLE',
    tableKeys: [
      {
        label: NOME_FONDO_LABEL,
        key: NOME_FONDO_KEY,
      },
      {
        label: 'Descrizione',
        key: 'lineName',
      },
      {
        label: IMPORTO_LABEL,
        key: IMPORTO_KEY,
        pipe: {
          key: 'currency',
          value: 'EUR',
        },
      },
      {
        label: PERCENTUALE_LABEL,
        key: PERCENTUALE_KEY,
        pipe: {
          key: 'percentage',
          value: '%',
        },
      },
    ],
  },
];
export const UNIT_uni20_countervalue_form_keys: IObjectKey[] = [
  {
    label: CONTROVALORE_LABEL,
    key: CONTROVALORE_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: DATA_ULTIMA_VAL_LABEL,
    key: DATA_ULTIMA_ELAB_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: TOT_VERSAMENTI_LABEL,
    key: TOT_VERSAMENTI_KEY,
  },
  {
    label: DATA_ULTIMO_VERSAMENTO_LABEL,
    key: DATA_UTLIMO_VERSAMENTO_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: DATA_ESTINZIONE_LABEL,
    key: DATA_ESTINZIONE_KEY,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: IPO_VAL_RISCATTO_PREMI_LABEL,
    key: IPO_VAL_RISCATTO_PREMI_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: IPO_VAL_RISCATTO_LORDO_LABEL,
    key: IPO_VAL_RISCATTO_LORDO_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: IPO_VAL_RISCATTO_NETTO_LABEL,
    key: IPO_VAL_RISCATTO_NETTO_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: IPO_VAL_RISCATTO_IMPOSTA_LABEL,
    key: IPO_VAL_RISCATTO_IMPOSTA_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: IPO_VAL_RISCATTO_BOLLO_LABEL,
    key: IPO_VAL_RISCATTO_BOLLO_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    }
  },
  {
    label: VALORE_POLIZZA_LABEL,
    key: 'policyValue.funds',
    type: 'TABLE',
    tableKeys: [
      {
        label: NOME_FONDO_LABEL,
        key: NOME_FONDO_KEY,
      },
      {
        label: 'Descrizione',
        key: 'lineName',
      },
      {
        label: IMPORTO_LABEL,
        key: IMPORTO_KEY,
        pipe: {
          key: 'currency',
          value: 'EUR',
        },
      },
      {
        label: NAV_LABEL,
        key: NAV_KEY,
        pipe: {
          key: 'currency',
          value: 'EUR',
        },
      },
      {
        label: PERCENTUALE_LABEL,
        key: PERCENTUALE_KEY,
        pipe: {
          key: 'percentage',
          value: '%',
        },
      },
      {
        label: DATA_LABEL,
        key: DATA_KEY,
        pipe: {
          key: 'date',
          value: null,
        }
      }
    ],
  },
];

export const customer_form_keys: IObjectKey[] = [
  {
    label: 'NDG cliente',
    key: NDG_CLIENTE_KEY,
  },
  {
    label: 'Cognome',
    key: 'policyHolder.surname',
    hidden: true,
  },
  {
    label: 'Nome',
    key: 'policyHolder.name',
    hidden: true,
  },
  {
    label: 'Nome',
    key: 'policyHolder.companyName',
    hidden: true,
  },
  {
    label: 'Codice Fiscale / P.IVA',
    key: POLICY_HOLDER_TAX_VAT_CODE_KEY,
    hidden: true,
  },
  {
    label: POLICY_HOLDER_DATA_NASCITA_LABEL,
    key: 'policyHolder.birthDate',
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: 'Codice Natura giuridica',
    key: POLICY_HOLDER_NATURA_GIURIDICA,
  },
];

export const customer_form_keys_PG: string[] = [
  'policyExtraInfo.ndg',
  'policyHolder.companyName',
  POLICY_HOLDER_TAX_VAT_CODE_KEY,
  POLICY_HOLDER_NATURA_GIURIDICA,
];

export const customer_form_keys_PF: string[] = [
  'policyExtraInfo.ndg',
  'policyHolder.surname',
  'policyHolder.name',
  POLICY_HOLDER_TAX_VAT_CODE_KEY,
  'policyHolder.birthDate',
  POLICY_HOLDER_NATURA_GIURIDICA,
];

export const tutor_form_keys_PF: IObjectKey[] = [
  {
    label: 'Cognome',
    key: 'surname',
  },
  {
    label: 'Nome',
    key: 'name',
  },
  {
    label: CODICE_FISCALE_LABEL,
    key: 'taxOrVatCode',
  },
  {
    label: POLICY_HOLDER_DATA_NASCITA_LABEL,
    key: 'birthDate',
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: 'Tipologia',
    key: 'type',
  },
];

export const tutor_form_keys_PG: IObjectKey[] = [
  {
    label: 'Ragione sociale',
    key: 'companyName',
  },
  {
    label: 'Partita IVA',
    key: 'taxOrVatCode',
  },
  {
    label: 'Tipologia',
    key: 'type',
  },
];

export const insured_form_keys: IObjectKey[] = [
  {
    label: 'Cognome',
    key: 'insured.surname',
    hidden: true,
  },
  {
    label: 'Nome',
    key: 'insured.name',
    hidden: true,
  },
  {
    label: CODICE_FISCALE_LABEL,
    key: 'insured.taxOrVatCode',
    hidden: true,
  },
  {
    label: POLICY_HOLDER_DATA_NASCITA_LABEL,
    key: 'insured.birthDate',
    pipe: {
      key: 'date',
      value: null,
    },
  },
];

export const beneficiary_form_keys: IObjectKey[] = [
  {
    label: 'Cognome',
    key: 'beneficiaryLastName',
  },
  {
    label: 'Nome',
    key: 'beneficiaryFirstName',
  },
  {
    label: CODICE_FISCALE_LABEL,
    key: 'beneficiaryTaxCode',
  },
  {
    label: POLICY_HOLDER_DATA_NASCITA_LABEL,
    key: 'beneficiaryBirthDate',
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: 'Luogo di nascita',
    key: 'beneficiaryBirthPlaceDate',
  },
  {
    label: 'Carta di identità',
    key: 'beneficiaryCardNumber',
  },
  {
    label: FULL_ADDRESS_UNI30_LABEL,
    key: 'beneficiaryAddress',
  },
  {
    label: 'Relazione',
    key: 'beneficiaryRelationship',
  },
  {
    label: 'Dettaglio legame',
    key: 'beneficiaryRelationDetail',
  },
  {
    label: '% beneficio',
    key: 'beneficiaryQuote',
  },
];

export const TCM_beneficiary_form_keys: IObjectKey[] = [
  {
    label: 'Cognome',
    key: 'beneficiaryLastName',
  },
  {
    label: 'Nome',
    key: 'beneficiaryFirstName',
  },
  {
    label: CODICE_FISCALE_LABEL,
    key: 'beneficiaryTaxCode',
  },
  {
    label: POLICY_HOLDER_DATA_NASCITA_LABEL,
    key: 'beneficiaryBirthDate',
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: 'Luogo di nascita',
    key: 'beneficiaryBirthPlaceDate',
  },
  {
    label: 'Carta di identità',
    key: 'beneficiaryCardNumber',
  },
  {
    label: FULL_ADDRESS_UNI30_LABEL,
    key: 'beneficiaryAddress',
  },
  {
    label: 'Relazione',
    key: 'beneficiaryRelationship',
  },
  {
    label: 'Dettaglio legame',
    key: 'beneficiaryRelationDetail',
  },
  {
    label: '% beneficio',
    key: 'beneficiaryQuote',
  },
];

export const TRAD_payment_method_form_keys: IObjectKey[] = [
  {
    label: MODALITA_PAGAMENTO_LABEL,
    key: null,
    defaultValue: ADDEBITO_CONTO_LABEL,
  },
  {
    label: CONTO_CORRENTE_LABEL,
    key: CONTO_CORRENTE_KEY,
  },
  {
    label: INTESTATARIO_CC_LABEL,
    key: INTESTATARIO_CC_KEY,
  },
  {
    label: IMPORTO_PREMI_SUCCESSIVI_LABEL,
    key: IMPORTO_PREMI_SUCCESSIVI_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: PERIODICITA_LABEL,
    key: PREMIO_KEY,
  },
];

export const TCM_payment_method_form_keys: IObjectKey[] = [
  {
    label: MODALITA_PAGAMENTO_LABEL,
    key: null,
    defaultValue: ADDEBITO_CONTO_LABEL,
  },
  {
    label: CONTO_CORRENTE_LABEL,
    key: CONTO_CORRENTE_KEY,
  },
  {
    label: INTESTATARIO_CC_LABEL,
    key: INTESTATARIO_CC_KEY,
  },
  {
    label: IMPORTO_PREMI_SUCCESSIVI_LABEL,
    key: IMPORTO_PREMI_SUCCESSIVI_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: PERIODICITA_LABEL,
    key: PREMIO_KEY,
  },
];

export const PREV_premium_payment_form_keys: IObjectKey[] = [
  {
    label: MODALITA_PAGAMENTO_LABEL,
    // key: 'intesaFurtherDetails.uni30.premiumPayment.paymentMethod',
    key: null,
    defaultValue: ADDEBITO_CONTO_LABEL,
  },
  {
    label: PERIODICITA_LABEL,
    key: PREMIO_KEY,
  },
  {
    label: IBAN_LABEL,
    key: IBAN_KEY, // Might use CONTO_CORRENTE_KEY for codeRapporto instead of IBAN
  },
  {
    label: IMPORTO_RATA_PERIODICA_LABEL,
    key: IMPORTO_PREMI_SUCCESSIVI_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: 'Importo versamento annuo',
    key: IMPORTO_PREMI_ANNUALE_KEY,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    label: 'Data versamento (ultimo versamento)',
    key: 'lastPaymentDate',
    pipe: {
      key: 'date',
      value: null
    }
  },

];

export const PREV_movements_form_keys: IObjectKey[] = [
  {
    label: null,
    key: 'intesaFurtherDetails.uni30.garanzie',
    type: 'TABLE',
    tableKeys: [
      {
        label: 'Garanzia',
        key: 'garanzia',
      },
      {
        label: 'Capitale premi piano',
        key: 'capitalePremiPiano',
        pipe: {
          key: 'currency',
          value: 'EUR'
        }
      },
      {
        label: 'Capitale premi piano estemporanei',
        key: 'capitalePremiEstemp',
        pipe: {
          key: 'currency',
          value: 'EUR'
        }
      },
      {
        label: 'Totale Capitale',
        key: 'totaleCapitale',
        pipe: {
          key: 'currency',
          value: 'EUR'
        }
      },
      {
        label: 'Premio annuo',
        key: 'premioAnnuo',
        pipe: {
          key: 'currency',
          value: 'EUR'
        }
      },
      {
        label: 'Data rivalutazione',
        key: 'dataRiv',
        pipe: {
          key: 'date',
          value: null,
        }
      },
    ],
    emptyStateMessage: 'Nessun Movimento Trovato.'
  },
];

export const policy_detail_tradizionale: IPolicyKeys = {
  header: TRAD_policy_header_keys,
  accordions: [
    {
      id: 'COUNTERVALUE',
      label: CONTROVALORE_LABEL,
      keys: TRAD_countervalue_form_keys,
    },
    {
      id: 'POLICY',
      label: 'Polizza',
      keys: TRAD_policy_form_keys,
    },
    {
      id: 'INSURED',
      label: 'Assicurato',
      keys: insured_form_keys,
    },
    {
      id: 'TUTOR',
      label: TUTORE_LABEL,
      keys: null,
    },
    {
      id: 'BENEFICIARY',
      label: 'Beneficiario',
      keys: beneficiary_form_keys,
    },
    {
      id: 'PAYMENT',
      label: MODALITA_PAGAMENTO_LABEL,
      keys: TRAD_payment_method_form_keys,
    },
    {
      id: 'DOCUMENTS',
      label: 'Documenti',
      keys: null,
    },
  ],
};

export const policy_detail_multiramo: IPolicyKeys = {
  header: MULTIRAMO_policy_header_keys,
  accordions: [
    {
      id: 'COUNTERVALUE',
      label: CONTROVALORE_LABEL,
      keys: MULTIRAMO_countervalue_form_keys,
    },
    {
      id: 'POLICY',
      label: 'Polizza',
      keys: TRAD_policy_form_keys,
    },
    {
      id: 'INSURED',
      label: 'Assicurato',
      keys: insured_form_keys,
    },
    {
      id: 'TUTOR',
      label: TUTORE_LABEL,
      keys: null,
    },
    {
      id: 'BENEFICIARY',
      label: 'Beneficiario',
      keys: beneficiary_form_keys,
    },
    {
      id: 'PAYMENT',
      label: MODALITA_PAGAMENTO_LABEL,
      keys: TRAD_payment_method_form_keys,
    },
    {
      id: 'DOCUMENTS',
      label: 'Documenti',
      keys: null,
    },
  ],
};

export const policy_detail_previdenziale: IPolicyKeys = {
  header: PREV_policy_header_keys,
  accordions: [
    {
      id: 'POLICY',
      label: 'Dati comparti',
      keys: PREV_policy_form_keys,
    },
    {
      id: 'TUTOR',
      label: TUTORE_LABEL,
      keys: null,
    },
    {
      id: 'BENEFICIARY',
      label: 'Beneficiario',
      keys: beneficiary_form_keys,
    },
    {
      id: 'PAYMENT',
      label: DATI_VERSAMRNTO_PREMIO_LABEL,
      keys: PREV_premium_payment_form_keys,
    },
    {
      id: 'MOVEMENTS',
      label: 'Patrimonio/Movimenti',
      keys: null,
    },
    {
      id: 'FORWARDS',
      label: 'Indirizzamenti',
      keys: PREV_forwards_form_keys,
    },
    {
      id: 'SWITCH',
      label: 'Switch',
      keys: PREV_switch_form_keys,
    },
    {
      id: 'ESTEMPORANEI',
      label: 'Estemporanei',
      keys: PREV_estemporanei_form_keys,
    },
    {
      id: 'LETTERS',
      label: 'Documentazione Inviata',
      keys: PREV_sent_docs_form_keys
    },
    {
      id: 'PAYMENT',
      label: 'Liquidazione/Anticipazioni',
      keys: PREV_liquidation_form_keys
    },
    {
      id: 'PAYMENT',
      label: 'Traferimenti',
      keys: PREV_transfers_form_keys
    },
    {
      id: 'PAYMENT',
      label: 'Scheda fiscalità',
      keys: PREV_fiscal_data_form_keys
    },
    {
      id: 'PAYMENT',
      label: 'Anticipazioni',
      keys: PREV_anticipazioni_form_keys
    },
    {
      id: 'PAYMENT',
      label: 'Dati Contributi',
      keys: PREV_datiContributi_form_keys
    },
    {
      id: 'PAYMENT',
      label: 'Dati Contributi Non dedotti',
      keys: PREV_datiContributiNonDedotti_form_keys
    },
    {
      id: 'PAYMENT',
      label: 'Dati Premio Produttività',
      keys: PREV_datiContributiPremio_form_keys
    },
  ],
};

export const policy_detail_tcm: IPolicyKeys = {
  header: TCM_policy_header_keys,
  accordions: [
    {
      id: 'COUNTERVALUE',
      label: CONTROVALORE_LABEL,
      keys: TCM_countervalue_form_keys,
    },
    {
      id: 'POLICY',
      label: 'Polizza',
      keys: TCM_policy_form_keys,
    },
    {
      id: 'INSURED',
      label: 'Assicurato',
      keys: insured_form_keys,
    },
    /* // mantieni qui perchè dovrà essere visibile per le TCM, ma non per le TCM/PPI
        {
            id: 'TUTOR',
            label: TUTORE_LABEL,
            keys: null
        }, */
    {
      id: 'BENEFICIARY',
      label: 'Beneficiario',
      keys: TCM_beneficiary_form_keys,
    },
    {
      id: 'PAYMENT',
      label: MODALITA_PAGAMENTO_LABEL,
      keys: TCM_payment_method_form_keys,
    },
    {
      id: 'DOCUMENTS',
      label: 'Documenti',
      keys: null,
    },
  ],
};

export const policy_detail_unit: IPolicyKeys = {
  header: UNIT_policy_header_keys,
  accordions: [
    {
      id: 'COUNTERVALUE',
      label: CONTROVALORE_LABEL,
      keys: UNIT_countervalue_form_keys,
    },
    {
      id: 'POLICY',
      label: 'Polizza',
      keys: TRAD_policy_form_keys,
    },
    {
      id: 'INSURED',
      label: 'Assicurato',
      keys: insured_form_keys,
    },
    {
      id: 'TUTOR',
      label: TUTORE_LABEL,
      keys: null,
    },
    {
      id: 'BENEFICIARY',
      label: 'Beneficiario',
      keys: beneficiary_form_keys,
    },
    {
      id: 'PAYMENT',
      label: MODALITA_PAGAMENTO_LABEL,
      keys: TRAD_payment_method_form_keys,
    },
    {
      id: 'DOCUMENTS',
      label: 'Documenti',
      keys: null,
    },
  ],
};

export const TRANSACTIONS_TABLE_KEYS: ITableKey[] = [
  {
    key: 'id',
    label: 'ID',
  },
  {
    key: 'operationDescription',
    label: 'Operazione',
  },
  {
    key: 'operationDate',
    label: 'Data richiesta',
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    key: 'effectDate',
    label: 'Data effetto',
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    key: 'userId',
    label: 'Utente',
  },
  {
    key: 'benefitAtDate',
    label: IMPORTO_LABEL,
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    key: 'operationStatus',
    label: 'Stato',
    type: 'BADGE',
  },
  {
    key: ETableActionType.DELETE,
    label: '',
    type: 'ACTION_ICON',
    actionIcon: 'cancel',
    color: 'warn',
    tooltipText: 'Annulla operazione',
    showIconFieldName: 'cancelOperation',
  },
  {
    key: ETableActionType.OPERATION,
    label: '',
    type: 'ACTION_ICON',
    actionIcon: 'visibility',
    color: 'primary',
    tooltipText: 'Visualizza operazione',
    showIconFieldName: 'showOperation',
  },
];

export const PAYMENTS_TABLE_KEYS: ITableKey[] = [
  {
    key: 'paymentId',
    label: 'ID',
  },
  {
    key: 'chargeDate',
    label: 'Data addebito',
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    key: 'paymentDate',
    label: DATA_SCADENZA_LABEL,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    key: 'paymentAmount',
    label: 'Importo lordo',
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    key: 'paymentStatus',
    label: 'Stato',
    type: 'BADGE',
  },
];

export const UNI20_PAYMENTS_TABLE_KEYS: ITableKey[] = [
  {
    key: 'paymentId',
    label: 'ID',
  },
  {
    key: 'paymentDescription',
    label: 'Descrizione',
  },
  {
    key: 'chargeDate',
    label: 'Data addebito',
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    key: 'paymentDate',
    label: DATA_SCADENZA_LABEL,
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    key: 'paymentAmount',
    label: 'Importo lordo',
    pipe: {
      key: 'currency',
      value: 'EUR',
    },
  },
  {
    key: 'paymentStatus',
    label: 'Stato',
    type: 'BADGE',
  },
];

export enum EPipeKeys {
  CURRENCY = 'currency',
  PERCENTAGE = 'percentage',
  DATE_FROM_BE = 'date',
}

export const CANNOT_OPERATE_WARN_MESSAGE =
  'Il cliente non ha firmato il modulo (OFS); non è possibile operare';
export const CONTRACTOR_DOC_EXPIRED_MESSAGE =
  'Il documento del contraente è scaduto; non è possibile operare';
export const CONTRACTOR_DOC_SERVICE_ERROR_MESSAGE =
  'In questo momento non è possibile recuperare la data del documento del contraente; non è possibile operare';
export const POLICY_CONSTRAINT_ERROR_MESSAGE =
  'Attenzione polizza vincolata. Per l’esecuzione delle operazioni procedere con la richiesta di Svincolo';

export const policy_holder_keys_PF: IObjectKey[] = [
  {
    label: 'NDG',
    key: 'ndg',
  },
  {
    label: CODICE_FISCALE_LABEL,
    key: 'taxOrVatCode',
    hidden: true,
  },
  {
    label: POLICY_HOLDER_DATA_NASCITA_LABEL,
    key: 'birthDate',
    pipe: {
      key: 'date',
      value: null,
    },
  },
  {
    label: 'Tipologia',
    key: 'type',
  },
];

export const policy_holder_keys_PG: IObjectKey[] = [
  {
    label: 'NDG',
    key: 'ndg',
  },
  {
    label: 'Partita IVA',
    key: 'taxOrVatCode',
    hidden: true,
  },
  {
    label: 'Tipologia',
    key: 'type',
  },
];

export const policy_detail_previdenziale_uni30: IPolicyKeys = {
  header: PREV_policy_header_keys,
  accordions: [
    {
      id: 'POLICY',
      label: 'Dati comparti',
      keys: PREV_policy_form_keys,
    },
    {
      id: 'TUTOR',
      label: TUTORE_LABEL,
      keys: null,
    },
    {
      id: 'BENEFICIARY',
      label: 'Beneficiario',
      keys: beneficiary_form_keys,
    },
    {
      id: 'PAYMENT',
      label: DATI_VERSAMRNTO_PREMIO_LABEL,
      keys: PREV_premium_payment_form_keys,
    },
    {
      id: 'MOVEMENTS',
      label: 'Patrimonio/Movimenti',
      keys: null,
    },
    {
      id: 'FORWARDS',
      label: 'Indirizzamenti',
      keys: PREV_forwards_form_keys,
    },
    {
      id: 'SWITCH',
      label: 'Switch',
      keys: null,
    },
    {
      id: 'ESTEMPORANEI',
      label: 'Estemporanei',
      keys: null,
    },
    {
      id: 'LETTERS',
      label: 'Documentazione Inviata',
      keys: PREV_sent_docs_form_keys
    },
    {
      id: 'PAYMENT',
      label: 'Liquidazione/Anticipazioni',
      keys: PREV_liquidation_form_keys
    },
    {
      id: 'TRANSFERS',
      label: 'Trasferimenti',
      keys: null
    },
    {
      id: 'FISCALCARD',
      label: 'Scheda fiscalità',
      keys: null
    }
  ],
};

export const TCM_VITA_PRODUCT_CODE = 'BPTDR2';
export const TCM_VITA_PRODUCT_DESCRIPTION_PG = 'Vita Impresa (V311)';
export const TCM_VITA_PRODUCT_DESCRIPTION_PF = 'Vita Valore (V311)';
